import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'sc-modal-body',
    templateUrl: './modal-body.component.html',
    styleUrls: ['./modal-body.component.scss'],
    standalone: false
})
export class ModalBodyComponent implements OnInit {

  @Input()
  maxHeight = 0;

  @Input()
  customClasses = "";

  constructor() { }

  ngOnInit(): void {
  }

}
